import classNames from 'classnames';

function Badge({ children, className, isCustom = false, ...props }) {
  return (
    <span
      className={classNames(className, { ['badge']: !isCustom })}
      {...props}
    >
      {children}
    </span>
  );
}

export default Badge;
